/* eslint-disable */
import React from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import CheckoutForm from "./CheckoutForm";

export default function Checkout(props) {
  const {
    type,
    planId,
    priceId,
    currency,
    changeType,
    customerId,
    changeTypeAt,
    subscriptionId,
    studentPlans,
    clientSecret,
    cardPay,
    setModalAlert,
  } = props;

  const stripePromiseUSD = loadStripe(process.env.REACT_APP_STRIPE_PROMISE_USD);
  const stripePromiseBRL = loadStripe(process.env.REACT_APP_STRIPE_PROMISE_BRL);

  const getStripePromise = (currency) => {
    switch (currency) {
      case "USD":
        return stripePromiseUSD;
      case "BRL":
        return stripePromiseBRL;
      default:
        return null;
    }
  };

  const stripePromise = getStripePromise(currency);

  const appearance = {
    theme: "stripe",
  };
  const options = {
    clientSecret: clientSecret,
    appearance,
  };

  return (
    <div style={{ width: "100%" }}>
      {clientSecret && (
        <Elements options={options} stripe={stripePromise}>
          <CheckoutForm
            type={type}
            planId={planId}
            priceId={priceId}
            cardPay={cardPay}
            customerId={customerId}
            changeType={changeType}
            loginUser={props.loginUser}
            changeTypeAt={changeTypeAt}
            clientSecret={clientSecret}
            studentPlanId={studentPlans}
            setModalAlert={setModalAlert}
            subscriptionId={subscriptionId}
          />
        </Elements>
      )}
    </div>
  );
}
